import { ReactElement } from "react";

import { CSSObject } from "@emotion/react";
import { Anchor, type AngelouCSS } from "@newsela/angelou";

import { cellLinkCss } from "../Cells.style";

const defaultProps = {
  __css: {},
};

interface CellLinkProps {
  value: string | ReactElement;
  href: string;
  __css?: CSSObject | AngelouCSS;
}

const CellLink = ({ value, href, __css }: CellLinkProps): ReactElement => {
  const textTransformCss = {
    textTransform: value ? "capitalize" : "none",
  } as const;

  return (
    <Anchor
      href={href}
      __cssFor={{
        root: [...cellLinkCss, textTransformCss, __css],
      }}
    >
      {value || href || "-"}
    </Anchor>
  );
};

CellLink.defaultProps = defaultProps;

export default CellLink;
